module.exports = __webpack_public_path__ + "static/img/hyper-tube-support_256.d47f82a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hyper-tube-support_256.png
// module id = N7EL
// module chunks = 0